import { isDesktop } from './PlatformUtils';

// 桌面端专用CSS样式注入
export const injectDesktopStyles = () => {
    if (typeof document === 'undefined') {
        return;
    }
    
    // Web 环境下总是注入样式（不再检查 isDesktop）
    const isWeb = typeof window !== 'undefined';
    if (!isWeb) {
        return;
    }

    // 避免重复注入
    if (document.getElementById('desktop-styles')) {
        return;
    }

    const style = document.createElement('style');
    style.id = 'desktop-styles';
    style.textContent = `
        /* 全局桌面端样式 */
        body {
            margin: 0;
            padding: 0;
            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
            overflow: hidden;
        }

        /* 应用根容器 */
        #root {
            width: 100vw;
            height: 100vh;
            display: flex;
            flex-direction: column;
        }

        /* React Navigation 底部导航修复 */
        [data-testid="bottom-tab-bar"] {
            display: flex !important;
            position: fixed !important;
            bottom: 0 !important;
            left: 0 !important;
            right: 0 !important;
            z-index: 1000 !important;
            background-color: white !important;
            border-top: 1px solid #e0e0e0 !important;
            height: 60px !important;
            box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1) !important;
        }

        /* 底部导航按钮 */
        [data-testid="bottom-tab-bar"] > * {
            display: flex !important;
            flex: 1 !important;
            flex-direction: column !important;
            align-items: center !important;
            justify-content: center !important;
            padding: 8px 4px !important;
            cursor: pointer !important;
            transition: background-color 0.2s !important;
        }

        [data-testid="bottom-tab-bar"] > *:hover {
            background-color: rgba(95, 154, 194, 0.1) !important;
        }

        /* 主内容区域调整 */
        [role="main"], .react-navigation__screen-container {
            padding-bottom: 60px !important;
            height: calc(100vh - 60px) !important;
            overflow-y: auto !important;
        }

        /* Windows标题栏样式 */
        .windows-title-bar {
            height: 32px;
            background-color: #2d2d30;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 16px;
            -webkit-app-region: drag;
            user-select: none;
            color: white;
            font-size: 14px;
        }

        .windows-title-bar .controls {
            -webkit-app-region: no-drag;
            display: flex;
        }

        .windows-title-bar .control-button {
            width: 46px;
            height: 32px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            color: white;
            font-size: 16px;
            transition: background-color 0.2s;
        }

        .windows-title-bar .control-button:hover {
            background-color: rgba(255, 255, 255, 0.1);
        }

        .windows-title-bar .close-button:hover {
            background-color: #e81123;
        }

        /* 滚动条样式 */
        ::-webkit-scrollbar {
            width: 8px;
            height: 8px;
        }

        ::-webkit-scrollbar-track {
            background: #f1f1f1;
            border-radius: 4px;
        }

        ::-webkit-scrollbar-thumb {
            background: #c1c1c1;
            border-radius: 4px;
        }

        ::-webkit-scrollbar-thumb:hover {
            background: #a8a8a8;
        }

        /* 聊天界面适配 */
        .chat-container {
            display: flex;
            flex-direction: column;
            height: 100%;
        }

        .chat-header {
            flex-shrink: 0;
            border-bottom: 1px solid #e0e0e0;
            background-color: white;
            z-index: 10;
        }

        .chat-messages {
            flex: 1;
            overflow-y: auto;
            padding: 16px;
            background-color: #f5f5f5;
        }

        .chat-input {
            flex-shrink: 0;
            border-top: 1px solid #e0e0e0;
            background-color: white;
            padding: 16px;
        }

        /* 联系人界面适配 */
        .contact-list {
            height: 100%;
            overflow-y: auto;
        }

        /* 我的界面适配 */
        .mine-container {
            height: 100%;
            overflow-y: auto;
            background-color: #f5f5f5;
        }

        /* 通用列表项样式 */
        .list-item {
            background-color: white;
            border-bottom: 1px solid #f0f0f0;
            padding: 12px 16px;
            cursor: pointer;
            transition: background-color 0.2s;
        }

        .list-item:hover {
            background-color: #f8f9fa;
        }

        /* 修复 TextInput 在 Web 上的输入问题 */
        input, textarea {
            -webkit-user-select: text !important;
            user-select: text !important;
            pointer-events: auto !important;
            -webkit-app-region: no-drag !important;
            cursor: text !important;
            z-index: 1 !important;
            position: relative !important;
        }

        /* 所有输入框：完全移除边框和焦点样式 - 使用最高优先级 */
        input,
        textarea,
        input[type="text"],
        input[type="password"],
        input[type="email"],
        input[type="tel"],
        input[type="number"],
        input[type="search"] {
            -webkit-appearance: none !important;
            appearance: none !important;
            background-color: transparent !important;
            border: none !important;
            border-width: 0 !important;
            border-style: none !important;
            border-color: transparent !important;
            outline: none !important;
            outline-offset: 0 !important;
            padding: 0 !important;
            margin: 0 !important;
            font-family: inherit !important;
            font-size: inherit !important;
            color: inherit !important;
            cursor: text !important;
            box-shadow: none !important;
            -webkit-box-shadow: none !important;
        }
        
        /* 所有输入框焦点状态：完全移除边框 - 使用最高优先级 */
        input:focus,
        input:active,
        input:focus-visible,
        input:focus-within,
        textarea:focus,
        textarea:active,
        textarea:focus-visible,
        textarea:focus-within {
            outline: none !important;
            outline-offset: 0 !important;
            border: none !important;
            border-width: 0 !important;
            border-style: none !important;
            border-color: transparent !important;
            box-shadow: none !important;
            -webkit-box-shadow: none !important;
        }
        
        /* 修复输入框容器的 pointer-events */
        input:not([disabled]):not([readonly]),
        textarea:not([disabled]):not([readonly]) {
            pointer-events: auto !important;
        }
        
        /* 确保输入框的父容器也可以接收事件 */
        div:has(> input),
        div:has(> textarea) {
            pointer-events: auto !important;
        }
        
        /* 防止输入框失去焦点 - 关键修复 */
        input:focus,
        textarea:focus {
            pointer-events: auto !important;
        }
        
        /* 确保输入框在鼠标事件中保持焦点 */
        input,
        textarea {
            touch-action: manipulation !important;
            -webkit-tap-highlight-color: transparent !important;
        }
        
        /* 防止鼠标事件导致焦点丢失 */
        input:active,
        textarea:active {
            pointer-events: auto !important;
            outline: none !important;
        }
        
        /* 确保点击输入框时不会触发父元素的点击事件 */
        input,
        textarea {
            -webkit-user-drag: none !important;
            user-drag: none !important;
        }
        
        /* 修复浏览器自动填充导致的焦点问题 */
        input:-webkit-autofill,
        input:-webkit-autofill:hover,
        input:-webkit-autofill:focus,
        input:-webkit-autofill:active {
            -webkit-box-shadow: 0 0 0 30px transparent inset !important;
            box-shadow: 0 0 0 30px transparent inset !important;
            -webkit-text-fill-color: inherit !important;
            transition: background-color 5000s ease-in-out 0s !important;
            pointer-events: auto !important;
            outline: none !important;
            border: none !important;
        }
        
        /* 确保自动填充的输入框可以正常聚焦 */
        input:-webkit-autofill:focus {
            -webkit-box-shadow: 0 0 0 30px transparent inset !important;
            box-shadow: 0 0 0 30px transparent inset !important;
            -webkit-text-fill-color: inherit !important;
        }
        
        /* 防止浏览器密码管理器干扰焦点 */
        input[type="password"]:-webkit-autofill,
        input[type="password"]:-webkit-autofill:hover,
        input[type="password"]:-webkit-autofill:focus {
            -webkit-box-shadow: 0 0 0 30px transparent inset !important;
            box-shadow: 0 0 0 30px transparent inset !important;
            pointer-events: auto !important;
        }

        /* 响应式设计 */
        @media (max-width: 768px) {
            [data-testid="bottom-tab-bar"] {
                height: 50px !important;
            }
            
            [role="main"], .react-navigation__screen-container {
                padding-bottom: 50px !important;
                height: calc(100vh - 50px) !important;
            }
        }
    `;
    
    document.head.appendChild(style);
    console.log('桌面端样式已注入');
};

// 自动注入样式
if (typeof window !== 'undefined') {
    // 立即注入
    injectDesktopStyles();
    
    // 在DOM加载完成后再次确保样式存在
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', injectDesktopStyles);
    }
}

